import "../App.scss";
import Sort from "../assets/images/sort.png";
import Filter from "../assets/images/filter.png";
import Help from "../assets/images/help.png";
import { Link } from "react-router-dom";
import "./PatientPage.scss";
import useStore from "../store/store";
import { useEffect, useState } from "react";

const Patients = () => {
  const [filteredPatients, setFilteredPatients] = useState([]);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [filterCriteria, setFilterCriteria] = useState({
    diagnosis: "",
    status: "",
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [sortConfig, setSortConfig] = useState({
    key: "name",
    direction: "asc",
  });
  const [currentPage, setCurrentPage] = useState(1); // Current page state
  const patientsPerPage = 10; // Number of patients per page

  //MongoDB
  const fetchPatients = useStore((state) => state.fetchPatients);
  const patients = useStore((state) => state.patients);

  useEffect(() => {
    fetchPatients();
  }, []);

  useEffect(() => {
    if (patients && patients.length > 0) {
      setFilteredPatients(patients);
    }
  }, [patients]);

  const diagnosis = (patient) => {
    let diagnosisText = "-";
    Object.values(patient.diagnosis.osteoarthritis).forEach((painLevel) => {
      if (painLevel !== "No Pain" && painLevel !== "Not applicable") {
        diagnosisText = "OA";
        return;
      }
    });
    return diagnosisText;
  };

  const handleSearchChange = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    setCurrentPage(1); // Reset to first page on search
    applySearchAndFilters(query, filterCriteria);
  };

  const handleFilterClick = () => {
    setShowFilterModal(!showFilterModal);
  };

  const handleSortClick = () => {
    const newDirection = sortConfig.direction === "asc" ? "desc" : "asc";
    setSortConfig({ key: sortConfig.key, direction: newDirection });
    applySort(newDirection);
  };

  const applySort = (direction) => {
    let sorted = [...filteredPatients];

    sorted.sort((a, b) => {
      let valueA, valueB;

      switch (sortConfig.key) {
        case "name":
          valueA = `${a.firstName} ${a.lastName}`.toLowerCase();
          valueB = `${b.firstName} ${b.lastName}`.toLowerCase();
          break;
        case "diagnosis":
          valueA = diagnosis(a).toLowerCase();
          valueB = diagnosis(b).toLowerCase();
          break;
        case "status":
          valueA = a.treatmentStatus.toLowerCase();
          valueB = b.treatmentStatus.toLowerCase();
          break;
        case "patientId":
          valueA = a.uid.toLowerCase();
          valueB = b.uid.toLowerCase();
          break;
        case "email":
          valueA = a.email.toLowerCase();
          valueB = b.email.toLowerCase();
          break;
        default:
          return 0;
      }

      if (direction === "asc") {
        return valueA > valueB ? 1 : -1;
      } else {
        return valueA < valueB ? 1 : -1;
      }
    });

    setFilteredPatients(sorted);
  };

  const applySearchAndFilters = (
    search = searchQuery,
    filters = filterCriteria
  ) => {
    let filtered = [...patients];

    if (search) {
      filtered = filtered.filter(
        (patient) =>
          `${patient.firstName} ${patient.lastName}`
            .toLowerCase()
            .includes(search) ||
          patient.uid.toLowerCase().includes(search) ||
          patient.email.toLowerCase().includes(search)
      );
    }

    if (filters.diagnosis) {
      filtered = filtered.filter(
        (patient) => diagnosis(patient) === filters.diagnosis
      );
    }

    if (filters.status) {
      filtered = filtered.filter(
        (patient) => patient.treatmentStatus === filters.status
      );
    }

    setFilteredPatients(filtered);
    applySort(sortConfig.direction);
  };

  const applyFilters = () => {
    setCurrentPage(1); // Reset to first page on filter
    applySearchAndFilters(searchQuery, filterCriteria);
    setShowFilterModal(false);
  };

  const clearFilters = () => {
    setFilterCriteria({ diagnosis: "", status: "" });
    setCurrentPage(1); // Reset to first page on clear
    applySearchAndFilters(searchQuery, { diagnosis: "", status: "" });
    setShowFilterModal(false);
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilterCriteria((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Pagination logic
  const totalPatients = filteredPatients.length;
  const totalPages = Math.ceil(totalPatients / patientsPerPage);
  const startIndex = (currentPage - 1) * patientsPerPage;
  const endIndex = Math.min(startIndex + patientsPerPage, totalPatients);
  const currentPatients = filteredPatients.slice(startIndex, endIndex);
  console.log("currentPatients ", currentPatients);
  const handlePrevClick = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextClick = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    <div className="pageContainer">
      <div className="patientHeader">
        <div className="h1 row space-between pageHeader centerAlign">
          <div>Patients</div>
          <div>
            <Link
              to={"/patients/addExistingPatient"}
              className="inlineBtn button1 h3 white"
              style={{
                background: "var(--hippieBlue)",
                textDecoration: "none",
              }}
            >
              + Add an existing Patient
            </Link>
            <Link
              to={"/patients/newPatient"}
              className="inlineBtn button1 h3 white"
              style={{
                marginLeft: "1.3rem",
                background: "var(--hippieBlue)",
                textDecoration: "none",
              }}
            >
              + Add new Patient
            </Link>
          </div>
        </div>

        <div
          className="row space-between centerAlign"
          style={{ padding: "0 5rem" }}
        >
          <div className="h2">
            <span>Total Patients </span>
            <span style={{ color: "var(--dustyGrey)" }}>
              ({filteredPatients.length})
            </span>
          </div>
          <div className="row centerAlign">
            <button className="icon-buttons" onClick={handleSortClick}>
              <img src={Sort} alt="Sort" />
            </button>
            <button className="icon-buttons" onClick={handleFilterClick}>
              <img src={Filter} alt="Filter" />
            </button>
            <button className="icon-buttons">
              <img src={Help} alt="Help" />
            </button>
          </div>
        </div>
      </div>

      {showFilterModal && (
        <div
          className="filter-modal"
          style={{
            position: "absolute",
            top: "150px",
            right: "20px",
            background: "white",
            padding: "1.5rem",
            borderRadius: "8px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
            zIndex: 1000,
          }}
        >
          <h3>Filter Patients</h3>
          <div style={{ margin: "1rem 0" }}>
            <label>Diagnosis:</label>
            <select
              name="diagnosis"
              value={filterCriteria.diagnosis}
              onChange={handleFilterChange}
              style={{ marginLeft: "0.5rem", padding: "0.3rem" }}
            >
              <option value="">All</option>
              <option value="OA">OA</option>
              <option value="-">No Diagnosis</option>
            </select>
          </div>
          <div style={{ margin: "1rem 0" }}>
            <label>Status:</label>
            <select
              name="status"
              value={filterCriteria.status}
              onChange={handleFilterChange}
              style={{ marginLeft: "0.5rem", padding: "0.3rem" }}
            >
              <option value="">All</option>
              <option value="On treatment">On treatment</option>
              <option value="Recovered">Recovered</option>
            </select>
          </div>
          <div style={{ marginTop: "1rem" }}>
            <button
              onClick={applyFilters}
              style={{
                background: "var(--hippieBlue)",
                color: "white",
                padding: "0.5rem 1rem",
                border: "none",
                borderRadius: "4px",
                marginRight: "0.5rem",
              }}
            >
              Apply
            </button>
            <button
              onClick={clearFilters}
              style={{
                background: "var(--dustyGrey)",
                color: "white",
                padding: "0.5rem 1rem",
                border: "none",
                borderRadius: "4px",
              }}
            >
              Clear
            </button>
          </div>
        </div>
      )}

      <div style={{ paddingTop: "3rem", marginLeft: "1.5rem" }}>
        <div className="col">
          <div
            className="row b2 patientRow patientTitle"
            style={{ color: "var(--dustyGrey)" }}
          >
            <div style={{ flex: 1.5 }}>Name</div>
            <div style={{ flex: 1.125 }}>Diagnosis</div>
            <div style={{ flex: 1.5 }} className="textCenter">
              Status
            </div>
            <div style={{ flex: 1 }}>Patient ID</div>
            <div style={{ flex: 2.5 }}>Email</div>
          </div>
          <div style={{ marginTop: "5rem" }}>
            {/* {patients && patients.map(patient => {
    return(
        <Link style={{textDecoration:"none", color:"var(--codGrey)"}} to={`/patients/${patient.uid}`} state={{ patient }}>
        <div className='row b2 patientRow'>
        <div style={{flex:1.5}}>{patient.firstName +" "+ patient.lastName}</div>
        <div style={{flex:1.125}}>{diagnosis(patient)}</div>
        <div style={{flex:1.5}} className='b2'>
            <div className='patientStatus textCenter' style={{ color:patient.treatmentStatus === "Recovered" ? "var(--green)": "var(--red)",background: patient.treatmentStatus === "Recovered" ? "#B3E3C7":"#F8C4C4"}}>{patient.treatmentStatus}</div>
            </div>
        <div style={{flex:1}}>{patient.uid}</div>
        <div style={{flex:2.5}}>{patient.email}</div>
    </div>
        </Link>
        )
}
)} */}
            {currentPatients &&
              currentPatients.map((patient) => {
                console.log("Patient deets ", patient);
                return (
                  <Link
                    style={{ textDecoration: "none", color: "var(--codGrey)" }}
                    to={`/patients/${patient.uid}`}
                    key={patient.uid}
                  >
                    <div className="row b2 patientRow">
                      <div style={{ flex: 1.5 }}>
                        {patient.firstName + " " + patient.lastName}
                      </div>
                      <div style={{ flex: 1.125 }}>{diagnosis(patient)}</div>
                      <div style={{ flex: 1.5 }} className="b2">
                        <div
                          className="patientStatus textCenter"
                          style={{
                            color:
                              patient.treatmentStatus === "Recovered"
                                ? "var(--green)"
                                : "var(--red)",
                            background:
                              patient.treatmentStatus === "Recovered"
                                ? "#B3E3C7"
                                : "#F8C4C4",
                          }}
                        >
                          {patient.treatmentStatus}
                        </div>
                      </div>
                      <div style={{ flex: 1 }}>{patient.uid}</div>
                      <div style={{ flex: 2.5 }}>{patient.email}</div>
                    </div>
                  </Link>
                );
              })}
          </div>
        </div>
      </div>
      <div
        className="row"
        style={{
          justifyContent: "flex-end",
          padding: "0.8rem 0",
          alignItems: "center",
        }}
      >
        <button
          className="icon-buttons b3"
          style={{ marginRight: "1.5rem" }}
          onClick={handlePrevClick}
          disabled={currentPage === 1}
        >
          &lt; Prev
        </button>
        <div className="b3">
          {startIndex + 1} - {endIndex} of {totalPatients}
        </div>
        <button
          className="icon-buttons b3"
          style={{ marginLeft: "1.5rem" }}
          onClick={handleNextClick}
          disabled={currentPage === totalPages}
        >
          Next &gt;
        </button>
      </div>
    </div>
  );
};

export default Patients;
